import React from 'react'
import { NewAppLayout } from '@/components/new-ux/layout/NewAppLayout'
import { LinkedInManagement } from "@/components/linkedin/LinkedInManagement"

const LinkedInManagementPage = () => {
  return (
    <NewAppLayout fullWidth>
      <LinkedInManagement />
    </NewAppLayout>
  )
}

export default LinkedInManagementPage
